module.exports = __webpack_public_path__ + "img/31.d76a2a3e.jpg";